export default __webpack_public_path__ + "static/media/Total poitns card.241dc08a.svg";